<template>
    <h2>Page Not Found! Maybe view our
        <router-link to='/teams'>Teams</router-link></h2>
</template>

<script>
export default {

}
</script>

<style>

</style>
